import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem } from '@/core/ui';
import { t } from '@/core/localization';
import { StockDisplayType } from '@/shared/modules/stock/models';
import { SelectStyled } from './StockDisplayTypeSelect.styled';
const StockDisplayTypeSelect = ({ value, disabled, onChange }) => {
    return (_jsxs(SelectStyled, { disabled: disabled, value: value ?? StockDisplayType.List, onChange: onChange, children: [_jsx(MenuItem, { value: StockDisplayType.List, children: t('display.as.list') }, StockDisplayType.List), _jsx(MenuItem, { value: StockDisplayType.GroupByCells, children: t('display.by.cells') }, StockDisplayType.GroupByCells)] }));
};
export { StockDisplayTypeSelect };
